import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import * as moment from "moment";
import { breadcrumbs } from "../../../../actions/appActions";
import DatePicker from "../../../../components/form/DateTime/DateTime";
import { Select } from "../../../../components/form/Select";
import loginInfo from "../../components/LoginInfo";
import {
  StatisticsFunkcionariGrid,
  StatisticsFunkcionariChybejiciOznameniGrid,
  StatisticsFunkcionariNeuplneOznameniGrid,
  StatisticsFunkcionariOpozdeneOznameniGrid,
  StatisticsFunkcionariVcasneOznameniGrid,
  StatisticsOznameniGrid,
  StatisticsVyzvyGrid,
  StatisticsKontrolyGrid,
  StatisticsPodpurneOrganyGrid,
  StatisticsPodnetyGrid,
  StatisticsZadostiGrid
} from "../../components/grids/StatisticsGrid";
import {
  getFunctionaryNoticeTypes,
  getForwardingReasons,
  markOfficialsAsInspected
} from "../../CroActions";

import { StatementTypeNoPt3 } from "../../enum";

const nowYear = new Date().getFullYear();

const STATISTICS = [
  { label: "Funkcionáři", value: "funkcionari",
    dateFilterBy: [
      { label: "Zahájení výkonu funkce", value: "workingPositions.start" },
      { label: "Ukončení výkonu funkce", value: "workingPositions.end" },
      { label: "Zápisu zahájení funkce", value: "workingPositions.from" },
      { label: "Zápisu ukončení funkce", value: "workingPositions.to" },
      { label: "Data zápisu do CRO", value: "created" },
      { label: "Data poslední změny", value: "updated" },
    ],
    specificStats: [
      { label: "Povinnost podat oznámení", value: "povinnost-oznameni",
        dateFilterBy: [
          { label: "Období povinnosti podat oznámení", value: "statementObligation" },
          { label: "Zahájení výkonu funkce", value: "start" },
          { label: "Ukončení výkonu funkce", value: "pos_end" },
          { label: "Zápisu zahájení funkce", value: "written_date_of_start" },
          { label: "Zápisu ukončení funkce", value: "written_date_of_end" },
          { label: "Data zápisu do CRO", value: "created" },
          { label: "Data poslední změny", value: "updated" },
        ],
        filters: [
          { label: "Typ oznámení", field: "type", values: StatementTypeNoPt3 },
        ],
        tip: "Volba filtru podle Období povinnosti podat oznámení umožňuje sledovat funkcionáře, kteří mají povinnost podat oznámení za zvolené období. U jiného typu období je povinnost počítána k aktuálnímu datu."
      },
      { label: "S chybějícím oznámením", value: "chybejici-oznameni",
        filters: [
          { label: "Typ oznámení", field: "type", values: StatementTypeNoPt3, dateFilterLabels: {
              INGOING: { from: "Datum zápisu zahájení funkce od", to: "Datum zápisu zahájení funkce do" },
              OUTGOING: { from: "Datum zápisu ukončení funkce od", to: "Datum zápisu ukončení funkce do" },
              ONGOING: { from: "Období povinnosti oznámení od", to: "Období povinnosti oznámení do" },
            }
          },
        ],
        tip: "U průběžného oznámení zvolené období DO určuje, za jaký rok mělo být oznámení podáno. Příklad: Nastavení DO menší nebo rovno 30.6." + nowYear + " sleduje oznámení za rok " + (nowYear - 1) + ", DO větší než 1.7." + nowYear + " za rok " + nowYear + "."
      },
      { label: "S neúplným oznámením", value: "neuplne-oznameni",
        dateFilterBy: [
          { label: "Data podání oznámení", value: "statementSent" },
          { label: "Zahájení výkonu funkce", value: "start" },
          { label: "Ukončení výkonu funkce", value: "pos_end" },
          { label: "Zápisu zahájení funkce", value: "written_date_of_start" },
          { label: "Zápisu ukončení funkce", value: "written_date_of_end" },
        ],
        filters: [
          { label: "Typ oznámení", field: "type", values: StatementTypeNoPt3 },
        ],
        tip: "Datumem podání oznámení se rozumí datum, kdy bylo oznámení naposledy podáno veřejným funkcionářem. Tedy v případě opravného podání je bráno v potaz datum opravného podání."
      },
      { label: "S opožděným oznámením", value: "opozdene-oznameni",
        dateFilterBy: [
          { label: "Data podání oznámení", value: "statementSent" },
          { label: "Zahájení výkonu funkce", value: "start" },
          { label: "Ukončení výkonu funkce", value: "pos_end" },
          { label: "Zápisu zahájení funkce", value: "written_date_of_start" },
          { label: "Zápisu ukončení funkce", value: "written_date_of_end" },
        ],
        filters: [
          { label: "Typ oznámení", field: "type", values: StatementTypeNoPt3 },
        ],
        tip: "Datumem podání oznámení se rozumí datum, kdy bylo oznámení naposledy podáno veřejným funkcionářem. Tedy v případě opravného podání je bráno v potaz datum opravného podání."
      },
      { label: "S včasně podaným oznámením", value: "vcasne-oznameni",
        dateFilterBy: [
          { label: "Zahájení výkonu funkce", value: "start" },
          { label: "Ukončení výkonu funkce", value: "pos_end" },
          { label: "Zápisu zahájení funkce", value: "written_date_of_start" },
          { label: "Zápisu ukončení funkce", value: "written_date_of_end" },
          { label: "Data zápisu do CRO", value: "created" },
          { label: "Data poslední změny", value: "updated" },
        ],
        filters: [
          { label: "Typ oznámení", field: "type", values: StatementTypeNoPt3 },
        ],
        tip: "Datumem podání oznámení se rozumí datum, kdy bylo oznámení naposledy podáno veřejným funkcionářem. Tedy v případě opravného podání je bráno v potaz datum opravného podání."
      },
    ]
  },
  { label: "Oznámení", value: "oznameni", dateFilterLabels: { from: "Datum podání oznámení od", to: "Datum podání oznámení do" },
    dateFilterBy: [
      { label: "Podání oznámení", value: "creationDate" },
      { label: "Poslední úpravy oznámení", value: "lastSaved" },
    ],
    tip: "Datumem poslední úpravy oznámení se rozumí datum, kdy bylo oznámení naposledy podáno veřejným funkcionářem. Tedy v případě opravného podání je bráno v potaz datum opravného podání."
  },
  { label: "Výzvy", value: "vyzvy", dateFilterLabels: { from: "Datum podání výzvy od", to: "Datum podání výzvy do" } },
  { label: "Kontroly", value: "kontroly", dateFilterLabels: { from: "Datum provedení kontroly od", to: "Datum provedení kontroly do" } },
  { label: "Podpůrné orgány", value: "podpurne-organy", dateFilterLabels: { from: "Datum zápisu do CRO od", to: "Datum zápisu do CRO do" } },
  { label: "Žádosti o nahlédnutí", value: "zadosti", dateFilterLabels: { from: "Datum podání žádosti od", to: "Datum podání žádosti do" } },
  { label: "Podněty k prošetření", value: "podnety", dateFilterLabels: { from: "Datum podání podnětu od", to: "Datum podání podnětu do" } },
];

const GRID_MAP = {
  funkcionari: StatisticsFunkcionariGrid,
  "chybejici-oznameni": StatisticsFunkcionariChybejiciOznameniGrid,
  "neuplne-oznameni": StatisticsFunkcionariNeuplneOznameniGrid,
  "opozdene-oznameni": StatisticsFunkcionariOpozdeneOznameniGrid,
  "vcasne-oznameni": StatisticsFunkcionariVcasneOznameniGrid,
  "povinnost-oznameni": StatisticsFunkcionariVcasneOznameniGrid,
  oznameni: StatisticsOznameniGrid,
  vyzvy: StatisticsVyzvyGrid,
  kontroly: StatisticsKontrolyGrid,
  "podpurne-organy": StatisticsPodpurneOrganyGrid,
  podnety: StatisticsPodnetyGrid,
  zadosti: StatisticsZadostiGrid,
};

const openInNewTab = (url) => window.open(url, "_blank");

const OPEN_DETAIL_HANDLER_MAP = {
  funkcionari: (push, baseUrl) => (row) => {openInNewTab(`${baseUrl}/funkcionari/form/${row.id}`);},
  "chybejici-oznameni": (push, baseUrl) => (row) => {openInNewTab(`${baseUrl}/funkcionari/form/${row.id}`);},
  "neuplne-oznameni": (push, baseUrl) => (row) => {openInNewTab(`${baseUrl}/funkcionari/form/${row.id}`);},
  "opozdene-oznameni": (push, baseUrl) => (row) => {openInNewTab(`${baseUrl}/funkcionari/form/${row.id}`);},
  "vcasne-oznameni": (push, baseUrl) => (row) => {openInNewTab(`${baseUrl}/funkcionari/form/${row.id}`);},
  "povinnost-oznameni": (push, baseUrl) => (row) => {openInNewTab(`${baseUrl}/funkcionari/form/${row.id}`);},
  oznameni: (push, baseUrl) => (row) => {if (row.id) openInNewTab(`${baseUrl}/funkcionari/${row.official.id}/oznameni/${row.id}`);},
  kontroly: (push, baseUrl) => (row) => {if (row.id) openInNewTab(`${baseUrl}/funkcionari/form/${row.official.id}`);},
  "podpurne-organy": (push, baseUrl) => (row) => {if (row.id) openInNewTab(`${baseUrl}/podpurne-organy/form/${row.id}`);},
  zadosti: (push, baseUrl) => (row) => {if (row.id) openInNewTab(`${baseUrl}/zadosti/form/${row.id}`);},
  podnety: (push, baseUrl) => (row) => {if (row.id) openInNewTab(`${baseUrl}/podnety/form/${row.id}`);},
};

class Statistics extends Component {
  state = {
    activeStat: null,
    baseFilter: {
      dateFilterBy: null,
      from: null,
      to: null,
      filters: {}
    },
    exporting: false,
    searchKey: 0,
    activeQuery: null,
    error: null,
    initializing: true,
    functionaryNoticeTypes: [],
    forwardingReasons: []
  };

  async componentDidMount() {
    this.props.breadcrumbs([{ label: "Statistiky" }]);
    if (!this.props.params.stat) {
      this.props.params.stat = "funkcionari";
    }

    const functionaryNoticeTypes = await getFunctionaryNoticeTypes(this.props.dispatch);
    const forwardingReasons = await getForwardingReasons(this.props.dispatch);
    this.setState(
      { ...this.getInitialDateFilters(), functionaryNoticeTypes: functionaryNoticeTypes.items, forwardingReasons: forwardingReasons.items, initializing: false },
      () => this.setActiveStat(this.props.params.stat)
    );
  }

  getInitialDateFilters() {
    const to = moment().endOf("day").toDate();
    const from = moment().subtract(1, "month").startOf("day").toDate();
    return { from, to };
  }

  getActiveStat() {
    const stat = this.props.params.stat || "funkcionari";
    return this.findStat(stat) || STATISTICS[0];
  }

  findStat(name) {
    let stat = STATISTICS.find((t) => t.value === name);
    if(!stat) {
      for(const t of STATISTICS) {
        if(t.specificStats) {
          stat = t.specificStats.find((st) => st.value === name);
          if(stat) break;
        }
      }
    }
    return stat;
  }

  findRootStat(stat) {
    if (!stat) return null;
    if (STATISTICS.includes(stat)) return stat;
    return STATISTICS.find((t) => t.specificStats && t.specificStats.includes(stat));
  }

  findParentStat(stat) {
    if (!stat || STATISTICS.includes(stat)) return null;
    return STATISTICS.find((t) => t.specificStats && t.specificStats.includes(stat)) || null;
  }

  onStatSelect = (stat) => () => {
    const { auth } = this.props;
    this.props.push(`${auth.startUrl}/statistiky/${stat}`);
    this.setActiveStat(stat);
  };

  setActiveStat = (stat) => {
    const activeStat = this.findStat(stat);
    this.setState({ activeStat, baseFilter: {
        ...this.state.baseFilter,
        filters: this.loadDefaultFilters(activeStat),
        dateFilterBy: activeStat.dateFilterBy ? activeStat.dateFilterBy[0].value : null
      }, activeQuery: null, error: null }, () => this.loadData());
  }

  loadDefaultFilters = (stat) => {
    if(!stat) return;

    if(stat.filters && stat.filters.length > 0) {
      const defaultFilters = {};
      stat.filters.forEach((filter) => {
        if(filter.values && filter.values.length > 0) {
          defaultFilters[filter.field] = filter.values[0].id;
        }
      });
      return defaultFilters;
    }
    return {};
  }

  getDateFiltersLabel = (stat, filterField) => {
    if((!stat || !stat.filters || stat.filters.length === 0) && !stat.dateFilterLabels) return { from: "Datum od", to: "Datum do" };

    if(stat.dateFilterLabels) return stat.dateFilterLabels;

    const typeFilter = stat.filters.find((filter) => filter.field === filterField);
    if(!typeFilter || !typeFilter.dateFilterLabels) return { from: "Datum od", to: "Datum do" };

    const labels = typeFilter.dateFilterLabels[this.state.baseFilter.filters[filterField]];
    if(!labels) return { from: "Datum od", to: "Datum do" };

    return labels;
  }

  loadData = () => {
    const { from, to, baseFilter } = this.state;
    if (!from || !to) {
      this.setState({ error: "Vyplňte datumové rozmezí." });
      return;
    }
    if (new Date(from) > new Date(to)) {
      this.setState({ error: "Datum od musí být před datem do." });
      return;
    }
    const dateFormat = "YYYY-MM-DD";
    const query = {
      from: moment(from).format(dateFormat),
      to: moment(to).format(dateFormat),
      dateFilterBy: baseFilter.dateFilterBy,
      ...baseFilter.filters
    };
    this.setState((prev) => ({
      searchKey: prev.searchKey + 1,
      activeQuery: query,
      error: null,
    }));
  }

  onRowClick = (row) => {
    const auth = this.props.auth;
    const stat = this.getActiveStat().value;
    const openDetail = OPEN_DETAIL_HANDLER_MAP[stat];
    if (openDetail) {
      openDetail(this.props.push, auth.startUrl)(row);
    }
  };

  getGridProps(stat) {
    const { functionaryNoticeTypes, forwardingReasons } = this.state;

    const GRID_PROPS_MAP = {
      funkcionari: {
        exportFileName: "Statistiky - Funkcionáři",
        allowCheck: true,
        moreCheckboxFns: true,
        moreCheckboxFnsItems: functionaryNoticeTypes.map((type) => ({
          label: type.name,
          value: type.id,
          onClick: (selected) => this.onCreateAppeal(type.id, selected)
        })),
        fnText: "Zaslat výzvu",
        otherCheckboxFns: [{ label: "Zkontrolováno", onClick: this.onOfficialsMarkInspected }]
      },
      "chybejici-oznameni": { exportFileName: "Statistiky - Funkcionáři s chybějícím oznámením" },
      "neuplne-oznameni": { exportFileName: "Statistiky - Funkcionáři s neúplným oznámením" },
      "opozdene-oznameni": { exportFileName: "Statistiky - Funkcionáři s opožděným oznámením" },
      "vcasne-oznameni": { exportFileName: "Statistiky - Funkcionáři s včasným oznámením" },
      oznameni: { exportFileName: "Statistiky - Oznámení" },
      vyzvy: { exportFileName: "Statistiky - Výzvy" },
      kontroly: { exportFileName: "Statistiky - Kontroly" },
      "podpurne-organy": { exportFileName: "Statistiky - Podpůrné orgány" },
      zadosti: { exportFileName: "Statistiky - Žádosti o nahlédnutí" },
      podnety: { exportFileName: "Statistiky - Podněty", forwardingReasons: forwardingReasons },
    };

    const DEFAULT_GRID_PROPS = { filterAlways: true, filtering: true, exportPosition: 'FILTER', showTotalCount: true };

    return Object.assign({}, DEFAULT_GRID_PROPS, GRID_PROPS_MAP[stat] || {});
  }

  onCreateAppeal = (noticeTypeId, selected) => {
    const { auth } = this.props;
    if(selected.length === 0) return;

    this.props.push((selected.length === 1) ?
        { pathname: `${auth.startUrl}/funkcionari/${selected[0]}/vyzva`, state: { noticeTypeId } } :
        { pathname: `${auth.startUrl}/funkcionari/hromadna-vyzva`,
          state: {
            officialsIds: selected,
            noticeTypeId: noticeTypeId
          }
        });
  }

  onOfficialsMarkInspected = async (selected) => {
    const { auth, dispatch } = this.props;
    await markOfficialsAsInspected(auth.startUrl, selected)(dispatch);
    this.loadData();
  }

  render() {
    const {
      from,
      to,
      searchKey,
      activeQuery,
      error,
      initializing,
      baseFilter,
      exporting
    } = this.state;

    if(initializing) return null;

    const activeStat = this.getActiveStat();
    const rootStat = this.findRootStat(activeStat);
    const parentStat = this.findParentStat(activeStat);
    const GridComponent = GRID_MAP[activeStat.value];
    const gridProps = this.getGridProps(activeStat.value);
    const gridUrl = parentStat ? `/spravce/api/statistika/${parentStat.value}/${activeStat.value}` : `/spravce/api/statistika/${activeStat.value}`;
    const gridName = `statisticsGrid_${activeStat.value}`;

    return (
      <div className="statisticsPage">
        <div className="pageTabs">
          <div className="statisticsSection__label">1. Výstup statistiky:</div>
          <div className="pageTabs__scroller pageTabs__scroller--archive">
            {STATISTICS.map((s) => (
              <button
                key={s.value}
                type="button"
                className={
                  rootStat.value === s.value
                    ? "pageTabs__tab pageTabs__tab--active"
                    : "pageTabs__tab"
                }
                onClick={this.onStatSelect(s.value)}
              >
                {s.label}
              </button>
            ))}
            {rootStat.specificStats && (
              <div>
              <div className="statisticsSection__label">Specifické statistiky pro <b>{rootStat.label}</b>:</div>
              <div className="pageTabs__scroller pageTabs__scroller--archive">
                {rootStat.specificStats.map((ss) => (
                  <button
                    key={ss.value}
                    type="button"
                    className={
                      activeStat.value === ss.value
                        ? "pageTabs__tab pageTabs__tab--active"
                        : "pageTabs__tab"
                    }
                    onClick={this.onStatSelect(ss.value)}
                  >
                    {ss.label}
                  </button>
                ))}
              </div>
              </div>
            )}
          </div>
        </div>

        <div className="statisticsSection__label">2. Základní filtr:</div>
        <div className="statisticsFilter">
          <div className="statisticsFilter__fields">
            {activeStat.filters && activeStat.filters.length > 0 && (
              <div className="statisticsFilter__field mid">
                {activeStat.filters.map((filter) => (
                  <div key={filter.field} className="statisticsFilter__field">
                    <label className="statisticsFilter__label">{filter.label}</label>
                    <Select
                      items={filter.values}
                      valueField="id"
                      labelField="label"
                      value={baseFilter.filters[filter.field] || null}
                      onChange={(value) => this.setState((prev) => ({
                        baseFilter: {
                          ...prev.baseFilter,
                          filters: {
                            ...prev.baseFilter.filters,
                            [filter.field]: value
                          }
                        }
                      }), () => this.loadData())}
                    />
                  </div>
                ))}
              </div>
            )}
            {activeStat.dateFilterBy && (
              <div className="statisticsFilter__field wide">
                <label className="statisticsFilter__label">Filtrovat období podle</label>
                <Select
                    items={activeStat.dateFilterBy}
                    valueField="value"
                    labelField="label"
                    value={baseFilter.dateFilterBy}
                    onChange={(value) => this.setState((prev) => ({
                      baseFilter: {
                        ...prev.baseFilter,
                        dateFilterBy: value
                      }
                    }), () => this.loadData())}
                />
              </div>
            )}
            <div className="statisticsFilter__field">
              <label className="statisticsFilter__label">{ this.getDateFiltersLabel(activeStat, "type").from }</label>
              <DatePicker
                name="from"
                value={from}
                onChange={(date) => this.setState({ from: date, error: null }, () => this.loadData())}
                dateOnly
              />
            </div>
            <div className="statisticsFilter__field">
              <label className="statisticsFilter__label">{ this.getDateFiltersLabel(activeStat, "type").to }</label>
              <DatePicker
                name="to"
                value={to}
                onChange={(date) => this.setState({ to: date, error: null }, () => this.loadData())}
                dateOnly
              />
            </div>
          </div>
          {activeStat.tip && <div className="statisticsFilter__tip">TIP: {activeStat.tip}</div>}
          {error && <div className="statisticsFilter__error">{error}</div>}
        </div>

        {activeQuery && (
          <div>
            <div className="statisticsSection__label">3. Vlastní filtry:</div>
            <GridComponent
              key={`stats_${activeStat.value}_${searchKey}`}
              gridName={gridName}
              url={gridUrl}
              query={activeQuery}
              filtering={false}
              adding={false}
              exportInSummary={true}
              exportFileName={gridProps.exportFileName}
              onRowClick={this.onRowClick}
              {...gridProps}
            />
          </div>
        )}
      </div>
    );
  }
}

export default connect(null, { breadcrumbs, push })(loginInfo(Statistics));
